import { put, select } from 'redux-saga/effects';
import { selectCallSessions, setActiveCallCount } from '../../../state/callSessions/callSessionsSlice';

// Active call types
const activeTypes = [
    'trying',
    'incomingProgressing',
    'outgoingProgressing',
    'accepted',
  ];
  
  // Helper function to get active count
  function getActiveCallCount(sessions) {
    return sessions.reduce((count, session) => 
      activeTypes.includes(session.status) ? count + 1 : count, 0);
  }
  
  // Main saga
  export function* updateActiveCountSaga() {
    const sessions = yield select(selectCallSessions);
    const count = getActiveCallCount(sessions);
    yield put(setActiveCallCount(count));
  }